module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3b"
  }, [_vm._v("Time to Blow Sam’s Mind")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_c('strong', [_vm._v("HEATHER GANNIS EXPERTLY SLID HER")]), _vm._v(" long, silky, shiny dark hair over her shoulder and shifted her weight in her seat. In the desk next to her Melanie was picking at her split ends behind her textbook. Typical chem lab activity.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Okay, class, what happens if I take the potassium nitrate and add it to its inverse?” Mr. Fowler asked from the front of the classroom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“You pass out from the fumes and we get out of class early?” Melanie whispered. Heather grinned with a careful mixture of amusement and detached boredom.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("The classroom door opened, and Gaia Moore slunk into her seat, two rows over and one back from Heather. Involuntarily Heather’s stomach clenched, her knuckles slowly turning white on her ballpoint pen.")])]), _c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Melanie’s brown eyes focused on Gaia. “What is she doing here today?” she whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“I know.” Heather nodded. “Mary Moss was killed two days ago,” she said softly. “You’d think that Xena, Warrior Bitchtress, would miss a few days of school.”")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Melanie smiled appreciatively. “You’d think,” she agreed.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_c('em', [_vm._v("But no,")]), _vm._v(" Heather thought bitterly, "), _c('em', [_vm._v("here she is. Looking as usual as if she slept in her Goodwill clothes.")])]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("A loud thump suddenly echoed from behind the two girls, and they both turned to see where it had come from. Gaia’s head was now slumped down on her desk. How rude.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Melanie swallowed a delicate snort.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heather smiled again. Thank God for people like Melanie. People who adored her. People who agreed that Gaia was a complete loser.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Ducking her head so Mr. Fowler couldn’t see her lips moving, Melanie went on. “You know, I can’t believe that anyone could like her, anyway. But Mary seemed to. Now Mary’s dead, and Gaia doesn’t even look upset. What a bitch.”")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }, [_vm._v("Heather nodded quietly. She completely agreed with Melanie, but right now she wasn’t in the mood ")]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("for gossip. She settled back, letting a studious look come over her face. Gaia Moore, girl loser. Ever since Gaia had shown up last September, Heather’s life had taken a decided turn for the worse. In fact, until last September just about the only really awful thing that had ever happened to Heather had been her boyfriend Ed’s accident, leaving him wheelchair bound. Heather shook her head. That was past history. A rough time. She was just thankful that she and Ed, after all this time, could still be friends. But why was a great guy like Ed also friends with that bitch? It didn’t make sense.")])]), _c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("Since Gaia had come here, Heather, the most popular girl in school, had been stabbed and almost died, had lost a good friend, had been burned with hot coffee, had been picked on and teased, and had practically broken up with Sam.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Oh God. Sam Moon. A photo montage, complete with corny, tinkly French music, began to play in Heather’s brain. Sam, sitting at an outdoor table at Dojo’s, eating a huge plate of french fries. The day he had bought her a Celtic love knot pin from a street stand in Soho. Sam, unbuttoning her shirt, breathing soft against her cheek. Heather’s eyes drifted closed as Mr. Fowler droned on about the false distinction between organic and inorganic substances, blah, blah, blah.")])]), _c('p', {
    staticClass: "indent"
  }, [_c('a', {
    attrs: {
      "id": "page_19"
    }
  }, [_vm._v("Heather and Sam had been going out for nine ")]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_vm._v("months now, and the last four months had been really iffy. They had been filled with anger, jealousy, hurt, infidelity. But mostly they had been filled with Gaia Moore. Gaia talking with Sam, Gaia appearing in Sam’s dorm room, Gaia distracting Sam, invading their lives. But Heather wasn’t the type to lose without a fight. It was time for her and Sam to get back on track. Time for Heather to reclaim her hold on him and put Gaia out of his thoughts forever. After all, she was Heather Gannis. If she couldn’t hold on to a boyfriend, who could? Yes, it was time to unsheathe her claws. Time to blow Sam’s mind. Heather smiled.")])]), _c('a', {
    attrs: {
      "id": "page_20"
    }
  }, [_c('p', {
    staticClass: "indent"
  }, [_vm._v("“What?” Melanie whispered.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Heather snapped her mind back to chem lab and noticed her friend looking at her expectantly. The same way "), _c('em', [_vm._v("most")]), _vm._v(" of her friends looked at her "), _c('em', [_vm._v("most")]), _vm._v(" of the time.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("“Oh, nothing,” she said.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9be30a28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ch05.vue
// module id = 90
// module chunks = 0